import script from "./select.vue?vue&type=script&lang=jsx"
export * from "./select.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__